module.exports = __webpack_public_path__ + "img/ship.9a52e9a9.svg";